export const getSafeRedirectPath = (redirect: string | null) => {
  if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//')) {
    return null
  }

  return redirect
}

export const getLoginRedirectPath = (
  pathname: string,
  search = '',
  hash = '',
) => `/login?redirect=${encodeURIComponent(`${pathname}${search}${hash}`)}`
